import { flattenReduxFormProps } from 'decorators';
import { Datepicker } from 'components/core/Datepicker';

export default flattenReduxFormProps(Datepicker);
